const upgradePriorityMap = {
	['LEITO']: 5,
	['SEMI-LEITO']: 4,
	['SEMILEITO']: 4,
	['EXECUTIVO']: 3,
	['DIRETO']: 2,
	['SEMI-DIRETO']: 1,
	['S/DIRETO']: 1,
	['CONVENCIONAL']: 0,
}

export const markUpgradableTicket = (item, _, arr) => {
	const sameTrips = arr
		.map((item, index) => Object.assign({ index }, item))
		.filter(
			(ticket) =>
				ticket.group == item.group &&
				ticket.arrival == item.arrival &&
				ticket.busClass != item.busClass &&
				ticket.departure == item.departure &&
				ticket.enterprise == item.enterprise &&
				(ticket.scheduleKey != item.scheduleKey ||
					(item.scheduleKey === null && ticket.scheduleKey === null))
		)

	if (sameTrips.length === 0) {
		return item
	}

	const priority = upgradePriorityMap[item.busClass.toUpperCase()]

	let highestPriority = priority
	let ticketWithHighestPriority = item

	for (const trip of sameTrips) {
		const currentPriority = upgradePriorityMap[trip.busClass.toUpperCase()]
		if (currentPriority <= highestPriority) continue
		highestPriority = currentPriority
		ticketWithHighestPriority = trip
	}

	const canUpgrade = highestPriority > priority
	// if (canUpgrade) {
	if (false) {
		item.canUpgrade = canUpgrade
		item.upgradeTo = ticketWithHighestPriority
	}

	return item
}
